module.exports = __webpack_public_path__ + "static/media/51_A.5f71de5c.png";